<template>
  <div>
    <div class="row col-md-12 m-0 p-0">
      <div class="col-md-12 p-0">
        <div class="panel panel-default panel-fill">
          <div class="panel-heading">
            <h3 class="panel-title">
              {{ trans("users.tabMenuLabelSettings") }}
            </h3>
          </div>
          <div class="panel-body">
            <div class="row col-md-12">
              <div class="mb-3 col-md-6">
                <div
                  class="form-group"
                  :class="{ 'has-error': errors.culture }"
                >
                  <label for="culture">{{
                    trans("users.languageLabel")
                  }}</label>
                  <i class="far fa-asterisk" />
                  <select2 v-model="user.culture" name="culture">
                    <option value="sv">
                      {{ trans("users.languageOptionSwedish") }}
                    </option>
                    <option value="en">
                      {{ trans("users.languageOptionEnglish") }}
                    </option>
                    <option value="nl">
                      {{ trans("users.languageOptionDutch") }}
                    </option>
                    <option value="de">
                      {{ trans("users.languageOptionGerman") }}
                    </option>
                    <option value="fr">
                      {{ trans("users.languageOptionFrench") }}
                    </option>
                    <option value="it">
                      {{ trans("users.languageOptionItalian") }}
                    </option>
                  </select2>

                  <form-error v-if="errors.culture" :errors="errors.culture" />
                </div>
              </div>
              <div class="mb-3 col-md-6">
                <div class="form-group">
                  <label for="userRole">{{
                    trans("users.userRoleLabel")
                  }}</label>
                  <select2
                    id="userRole"
                    disabled
                    name="userRole"
                    :model-value="currentRole"
                  >
                    <option value />
                    <option value="user">
                      {{ trans("roles.user") }}
                    </option>
                    <option value="consultant">
                      {{ trans("roles.consultant") }}
                    </option>
                    <option value="senior_consultant">
                      {{ trans("roles.senior_consultant") }}
                    </option>
                    <option value="wound_user">
                      {{ trans("roles.wound_user") }}
                    </option>
                    <option value="user_without_clinical_view">
                      {{ trans("roles.user_without_clinical_view") }}
                    </option>
                  </select2>
                </div>
              </div>
            </div>
            <div class="row col-md-12">
              <div class="mb-3 col-md-6">
                <DerToggleWithLabel
                  v-model="user.hide_personal_data"
                  :label="trans('users.hidePersonalNoLabel')"
                />
              </div>
              <div class="mb-3 col-md-6">
                <DerToggleWithLabel
                  v-model="user.hide_case_answers"
                  :label="trans('users.hideConsultAnswerLabel')"
                />
              </div>
            </div>

            <span class="text-left"
              ><i class="far fa-asterisk" />
              {{ trans("center.requiredField") }}</span
            >
          </div>
        </div>
      </div>
    </div>

    <div class="row col-md-12 m-0 p-0">
      <div class="col-md-6 pl-0">
        <div class="panel panel-default panel-fill">
          <div class="panel-heading">
            <h3 class="panel-title">
              {{ trans("users.externalResursHeadline") }}
            </h3>
          </div>
          <div class="panel-body">
            <div class="col-md-12">
              <div class="form-group">
                <DerToggleWithLabel
                  :model-value="hasAnyExternalResourceRole"
                  :label="trans('roles.external_resource')"
                  @update:model-value="updateHasAnyExternalResourceRole"
                />
                <p class="mb-3">
                  <small>{{
                    trans("users.externalResourceRoleConsent")
                  }}</small>
                </p>

                <select2
                  v-if="hasAnyExternalResourceRole"
                  name="externalResourceRole"
                  :model-value="selectedExternalResourceRole"
                  disable-clear="true"
                  @update:model-value="updateSelectedExternalResourceRole"
                >
                  <option value="external_resource">
                    {{ trans("roles.external_resource_full_title") }}
                  </option>
                  <option value="region_external_resource">
                    {{ trans("roles.region_external_resource_full_title") }}
                  </option>
                </select2>
              </div>
              <table class="table table-hover">
                <tbody>
                  <tr
                    v-for="(externalResource, index) in externalResourcesList"
                    :key="index"
                    data-test="external-resource-row"
                  >
                    <td v-if="externalResource">
                      {{ externalResource.case_no }}
                    </td>
                  </tr>
                  <button
                    v-if="externalResources && externalResources.length > 5"
                    class="btn btn-grey btn-lg btn-block mt-2"
                    data-test="external-resource-show-all"
                    @click="showAllExternalCases = !showAllExternalCases"
                  >
                    <i
                      :class="[
                        showAllExternalCases ? 'fa-angle-up' : 'fa-angle-down',
                        'fas',
                      ]"
                    />
                    {{
                      showAllExternalCases
                        ? trans("center.showLess")
                        : trans("examination.consultationShowAllButton")
                    }}
                  </button>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 p-0">
        <div class="panel panel-default panel-fill">
          <div class="panel-heading">
            <h3 class="panel-title">
              {{ trans("users.resursHeadline") }}
            </h3>
          </div>
          <div class="panel-body">
            <div class="form-group">
              <label for="primaryCenter">{{
                trans("users.primaryCenterLabel")
              }}</label>
              <select2 v-model="primaryCenter.id" name="primaryCenter" disabled>
                <option
                  v-for="(center, index) in centers"
                  :key="index"
                  :value="center.id"
                >
                  {{ center.name }}
                </option>
              </select2>
            </div>

            <div v-if="connectedCenters.length !== 0" class="form-group">
              <label for="connectedCenters">{{
                trans("users.connectedCentersLabel")
              }}</label>
              <table class="table table-hover">
                <tbody>
                  <tr v-for="(center, index) in connectedCenters" :key="index">
                    <td v-if="!center.pivot.is_primary">
                      {{ center.name }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 pl-0">
        <UserQuicksilvaConnection />
      </div>
    </div>
  </div>
</template>

<script>
import DerToggleWithLabel from "../../design-system/DerToggleWithLabel.vue";
import UserQuicksilvaConnection from "./UserQuicksilvaConnection.vue";
import UserRolesMixin from "../../mixins/UserRolesMixin.vue";

export default {
  components: {
    DerToggleWithLabel,
    UserQuicksilvaConnection,
  },
  mixins: [UserRolesMixin],
  props: {
    user: {
      allow_external_resource: Boolean,
      hide_case_answers: Boolean,
      hide_personal_data: Boolean,
      culture: String,
    },
    primaryCenter: {},
    centers: {},
    externalResources: {},
    errors: {},
    userRoles: {
      external_resource: Boolean,
      region_external_resource: Boolean,
    },
    currentRole: String,
  },
  data: function () {
    return {
      showAllExternalCases: false,
    };
  },
  computed: {
    connectedCenters: function () {
      return this.centers.filter((center) => {
        return center.id !== this.primaryCenter.id;
      });
    },
    externalResourcesList: function () {
      if (
        !this.showAllExternalCases &&
        this.externalResources &&
        this.externalResources.length > 5
      ) {
        return this.externalResources.slice(0, 5);
      } else {
        return this.externalResources;
      }
    },
  },
};
</script>
